import React from 'react';

interface ErrorMessageProps {
  title?: string; // Optional Title
  description?: string; // Error Details
  onRetry?: () => void; // Retry Button Handler
}


const ErrorMessage: React.FC<ErrorMessageProps> = ({
  title = 'Something went wrong!',
  description = 'Please try again later or contact support.',
  onRetry,
}) => {
    window.location.href = "/dashboard"
  return (
    <div className="flex flex-col items-center justify-center h-screen p-6 bg-red-100 text-red-800 rounded-md shadow-md">
      <svg
        className="w-16 h-16 text-red-600 mb-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M18.364 5.636l-12.728 12.728M5.636 5.636l12.728 12.728"
        />
      </svg>
      <h2 className="text-2xl font-bold mb-2">{title}</h2>
      <p className="text-center text-sm mb-4">{description}</p>
      
        <button
          onClick={onRetry}
          className="px-3 py-2 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-md"
        >
          Retry
        </button>
    </div>
  );
};

export default ErrorMessage;
